import { Spinner } from '@components/core-ui/spinners/Spinner';
import styled from 'styled-components';

export const TopSpinner = styled(Spinner)`
  top: 0;
  left: 0;
`;
